// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__VILy5","label":"LanguagePicker_label__7crOO","icon":"LanguagePicker_icon__0+alQ"};